import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OnBoardingSelectedAnswers } from '../onBoarding/types';

type InitialStateType = {
  isModalOpen: boolean;
  authProvider: 'apple' | 'google' | null;
  onBoardingAnswers: null | OnBoardingSelectedAnswers;
};

const initialState: InitialStateType = {
  isModalOpen: false,
  authProvider: null,
  onBoardingAnswers: null,
};

const mergeUserSlice = createSlice({
  name: 'mergeUser',
  initialState,
  reducers: {
    initMergeUser: (state, action: PayloadAction<InitialStateType>) => action.payload,
    resetMergeUser: () => initialState,
  },
});

export const { initMergeUser, resetMergeUser } = mergeUserSlice.actions;
export default mergeUserSlice.reducer;
